export default {
  extendLabel: {
    id: 'rm_article_detail_extend',
    defaultMessage: 'Read in the extended view',
  },
} as const
